export default __webpack_public_path__ + "static/media/Poule-DOr-Logo-2.6911bb51.jpg";